<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="center" v-if="complete">
    <div>
      <el-row 
      v-for="(array, $index) in fieldData" 
      class='bg-wh bor-gray p-b-10 m-t-20' 
      v-if="array[0].default.show" 
      :class="{ 'groupNameHidden': !array[0].default.group }">
      <!-- <el-row v-for="(array, $index) in fieldData" class='bg-wh bor-gray' v-if="array[0].default.show" :class="{'groupNameHidden': !array[0].default.group}"> -->
        <div class="p-t-40" v-if="$index == 0 && !array[0].default.group"></div>
        <h5 class="form-group-name" v-if='array[0].default.group'>{{array[0].default.group}}</h5>
        <div v-for="(item, index) in array" class="p-l-20 p-r-20" v-if="!isHidden(item)">
          <el-col :span="getCol(item.default.layout)" style="min-height:80px">
            <!-- <div class="p-l-100 p-r-100"> -->
            <div>
              <el-form-item :label="item.default.title" :prop="item.default.name" v-if="item.default.type != TYPE_SUBFORM && !isHidden(item)" >
              <honray-input
                  v-model="form[item.default.name]"
                  :rules="rules"
                  :name="item.default.name"
                  :type="item.input.write_type"
                  :defaultValue="item.input.write_default"
                  :minLength="item.input.write_min"
                  :maxLength="item.input.write_max"
                  :disabled="isReadonly(item)"
                  :decimal="item.input.decimal"
                  :isNeed="item.default.is_needed === 1"
                  :isUnique="item.input.is_unique == 1"
                  :modelId="modelId"
                  :fieldId="item.default.field_id"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_INPUTTEXT">
              </honray-input>
              <honray-password
                  v-model="form[item.default.name]"
                  :rules="rules"
                  :name="item.default.name"
                  :encryptType="item.password.encrypt_type"
                  :encryptSplit="item.password.encrypt_split"
                  :minLength="item.password.write_min"
                  :maxLength="item.password.write_max"
                  :disabled="isReadonly(item)"
                  :isNeed="item.default.is_needed === 1"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_PASSWORD">
              </honray-password>
              <honray-textarea
                  v-model="form[item.default.name]"
                  :rules="rules"
                  :name="item.default.name"
                  :defaultValue="item.textarea.write_default"
                  :minLength="item.textarea.write_min"
                  :maxLength="item.textarea.write_max"
                  :disabled="isReadonly(item)"
                  :isNeed="item.default.is_needed === 1"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_TEXTAREA">
              </honray-textarea>
              <honray-radio
                  v-model="form[item.default.name]"
                  :rules="rules"
                  :name="item.default.name"
                  :options="item.options"
                  :disabled="isReadonly(item)"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_RADIO">
              </honray-radio>
              <honray-checkbox
                  v-model="form[item.default.name]"
                  :rules="rules"
                  :name="item.default.name"
                  :selectMin="item.checkbox.select_min"
                  :selectMax="item.checkbox.select_max"
                  :options="item.options"
                  :disabled="isReadonly(item)"
                  :isNeed="item.default.is_needed === 1"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_CHECKBOX">
              </honray-checkbox>
              <honray-select
                  v-model="form[item.default.name]"
                  :rules="rules"
                  :name="item.default.name"
                  :options="item.options"
                  :disabled="isReadonly(item)"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_SELECT">
              </honray-select>
              <honray-struct
                  v-model="form[item.default.name]"
                  :selectType="item.struct.select_type"
                  :range="item.struct.select_range"
                  :rules="rules"
                  :default="item.struct.select_default"
                  :name="item.default.name"
                  :options="item.options"
                  :disabled="isReadonly(item)"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_STRUCT">
              </honray-struct>
              <honray-people
                  v-model="form[item.default.name]"
                  :selectType="item.people.select_type"
                  :range="item.people.select_range"
                  :rules="rules"
                  :default="item.people.select_default"
                  :options="item.options"
                  :disabled="isReadonly(item)"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_PERSON">
              </honray-people>
              <honray-user
                  v-model="form[item.default.name]"
                  v-if="item.default.type == TYPE_USER"
                  :disabled="isReadonly(item)"
                  :isNeed="item.default.is_needed === 1"
                  :user="item.user_info">
              </honray-user>
              <honray-date
                  v-model="form[item.default.name]"
                  :rules="rules"
                  :name="item.default.name"
                  :type="item.date.type"
                  :config="item.date"
                  :isRange="item.date.range_status == 1"
                  placeholder="选择日期"
                  :disabled="isReadonly(item)"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_DATE">
              </honray-date>
              <honray-time
                  v-model="form[item.default.name]"
                  :rules="rules"
                  :name="item.default.name"
                  :type="item.time.select_type"
                  :config="item.time"
                  :isRange="item.time.range_status == 1"
                  placeholder="选择时间"
                  :disabled="isReadonly(item)"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_TIME">
              </honray-time>
              <honray-datetime
                  v-model="form[item.default.name]"
                  :rules="rules"
                  :name="item.default.name"
                  :config="item.datetime"
                  :isRange="item.datetime.range_status == 1"
                  placeholder="选择日期时间"
                  :disabled="isReadonly(item)"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_BOTH_DATE_TIME">
              </honray-datetime>
              <honray-upload
                  v-model="form[item.default.name]"
                  :title="item.default.title"
                  :name="item.default.name"
                  :config="item.file"
                  :uploadUrl="host + 'form/upload/' + item.default.field_id"
                  :disabled="isReadonly(item)"
                  v-if="item.default.type == TYPE_FILE"
                  @uploading="uploading">>
              </honray-upload>
              <honray-upload-img
                v-model="form[item.default.name]"
                :disabled="isReadonly(item)"
                :id="item.default.field_id"
                :config="item.image"
                :uploadUrl="host + 'form/upload/' + item.default.field_id"
                v-if="item.default.type == TYPE_PHOTO">
              </honray-upload-img>
              <honray-editor
                  v-model="form[item.default.name]"
                  :ref="item.default.name"
                  :id="item.default.name"
                  :col="item.default.layout"
                  :width="650"
                  :height="200"
                  :uploadImgUrl="item.uploadImgUrl"
                  :hideLinkImg="item.hideLinkImg"
                  :codeDefaultLang="item.editor.pc_code_type"
                  :mapKey="item.editor.pc_map_key"
                  :fileMaxSize="item.editor.pc_file_max"
                  :fileUnit="getUnitText(item.editor.pc_file_unit)"
                  :disabledMenus="item.disabledMenus"
                  :usePlupload="false"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_EDITOR && !isReadonly(item)">
              </honray-editor>
              <div
                  v-html="form[item.default.name]"
                  v-if="item.default.type == TYPE_EDITOR && isReadonly(item)">
              </div>
              <honray-cascader
                  v-model="form[item.default.name]"
                  :id="item.default.field_id"
                  :disabled="isReadonly(item)"
                  :type="item.link.type"
                  :filterable="item.link.has_search == 1"
                  :showAllLevels="item.link.result_show == CASCADER_SHOW_FULL"
                  :areaLimit="item.link.area_limit == 1"
                  :areaConfig="item.link.area_config"
                  @input="valueChange(item)"
                  v-if="item.default.type == TYPE_CASCADER">
              </honray-cascader>
              <honray-foreignkey
                  v-model="form[item.default.name]"
                  :disabled="isReadonly(item)"
                  :id="item.default.field_id"
                  :name="item.default.name"
                  :filterable="item.key.has_search == 1"
                  :isLink="item.key.is_link == 1"
                  :linkField="item.key.link_pid"
                  :efficientOptions="item.options"
                  :majorField="item.default.key_major"
                  :depentField="item.default.key_depent"
                  :type="item.key.type"
                  :keyItem="item"
                  :keyFilter="item.default.key_filter"
                  :keyCascade="item.default.key_cascade"
                  :keyFillin="item.default.key_fillin"
                  :extraFieldList="extraFieldList"
                  :hasNull="item.key.has_null == 1"
                  @input="valueChange(item)"
                  @setEfficientOptions="setEfficientOptions"
                  @setKeyOptions="setKeyOptions"
                  @setKeyData="setKeyData"
                  v-if="item.default.type == TYPE_FOREIGNKEY">
              </honray-foreignkey>
              <honray-dealtime
                  v-model="form[item.default.name]"
                  :unit="item.deal_time.unit"
                  v-if="item.default.type == TYPE_DEALTIME">
              </honray-dealtime>
              <honray-relate
                v-model="form[item.default.name]"
                :disabled="isReadonly(item)"
                :id="item.default.field_id"
                :name="item.default.name"
                :config="item.multi_link"
                :rules="rules"
                :api="'multi_link'"
                :is-need="item.default.is_needed"
                v-if="item.default.type == TYPE_MULTIRELATE">
              </honray-relate>
              <honray-relate
                v-model="form[item.default.name]"
                :disabled="isReadonly(item)"
                :id="item.default.field_id"
                :name="item.default.name"
                :config="item.child"
                :rules="rules"
                :api="'child'"
                :is-need="item.default.is_needed"
                v-if="item.default.type == TYPE_SUBRELATE">
              </honray-relate>
              <honray-interface
                v-model="form[item.default.name]"
                :disabled="isReadonly(item)"
                :id="item.default.field_id"
                :config="item.interface"
                :rules="rules"
                v-if="item.default.type == TYPE_OBTAIN_CONTENT"
                @transferInfo='transferInfo'
                ></honray-interface>
              <div class="form-tips" v-if="item.default.tips">{{ item.default.tips }}</div>
            </el-form-item>
              <div v-if="item.default.type == TYPE_SUBFORM && !isHidden(item)">
              <honray-subform
                v-model="form[item.default.name]"
                :name="item.default.name"
                :title="item.default.title"
                :inputList="item.form.data"
                :dataLimit="item.form.write_num"
                :disabled="isReadonly(item)"
                :rules="rules">
              </honray-subform>
            </div>
            </div>
          </el-col>
          <template v-if="item.default.type == TYPE_FOREIGNKEY">
            <el-col v-for="depent in item.default.key_depent" :span="getCol(item.default.layout)" class='foreign m-h-80'>
              <el-form-item :label="depent.title">
                <el-input class="h-40 w-100p mw-300" disabled v-model="keyData[item.default.name][form[item.default.name]][depent.name]" v-if="form[item.default.name] && keyData[item.default.name] && keyData[item.default.name][form[item.default.name]]"></el-input>
                <el-input class="h-40 w-100p mw-300" disabled v-else></el-input>
              </el-form-item>
            </el-col>
          </template>
        </div>
      </el-row>
    </div>
    <slot></slot>
  </el-form>
</template>

<style scoped>
  .m-h-80 {
    min-height: 80px;
  }
  .top-title {
    top: 0px;
    left: 0px;
    width: 100%
  }
  .rowFormClass .el-form-item{
    margin-right: 10px;
  }
  #pullAllWidth{
    width:100% !important;
  }
  .pullAllWidth{
    width:100% !important;
  }
  .pullAllWidth .el-input{
    width:100% !important;
  }
  .pullAllWidth .el-select{
    width:100% !important;
  }
  .pullAllWidth .el-date-picker{
    width:100% !important;
  }
  .pullAllWidth .el-date-editor{
    width:100% !important;
  }
  .pullAllWidth .el-time-select{
    width:100% !important;
  }
  .pullAllWidth .el-cascader{
    width:100% !important;
  }
  .groupNameHidden{
    margin-top: 0px !important;
    border-top: 0px !important;
    margin-top: -1px !important;
  }
</style>

<script>
  /**
   * @author Duoremix
   * @param Array formField 控件数据
   * @param Function isReadonly 是否只读判断函数
   * @param Object form 表单数据
   * @param Function selectChange 可选控件变化的方法
   * @param Boolean complete 是否已完成初始化
   */
  import http from '../../../../assets/js/http'
  import Stack from '../../../../assets/js/stack'
  import _verify from '../../../../assets/js/verify'
  import modelConfig from '../../../../config/modelConfig'
  import flowConfig from '../../../../config/flowConfig'
  import cmsConfig from '../../../../config/cmsConfig'
  import honrayInput from '../inputs/honrayInput.vue'
  import honrayPassword from '../inputs/honrayPassword.vue'
  import honrayTextarea from '../inputs/honrayTextarea.vue'
  import honrayRadio from '../inputs/honrayRadio.vue'
  import honrayCheckbox from '../inputs/honrayCheckbox.vue'
  import honraySelect from '../inputs/honraySelect.vue'
  import honrayStruct from '../inputs/honrayStruct.vue'
  import honrayPeople from '../inputs/honrayPeople.vue'
  import honrayDate from '../inputs/honrayDate.vue'
  import honrayTime from '../inputs/honrayTime.vue'
  import honrayDatetime from '../inputs/honrayDatetime.vue'
  import honrayUpload from '../inputs/honrayUpload.vue'
  import honrayEditor from '../inputs/honrayEditor.vue'
  import honrayCascader from '../inputs/honrayCascader.vue'
  import honraySubform from '../inputs/honraySubform.vue'
  import honrayForeignkey from '../inputs/honrayForeignkey.vue'
  import honrayUser from '../inputs/honrayUser.vue'
  import honrayDealtime from '../inputs/honrayDealtime.vue'
  import honrayUploadImg from '../inputs/honrayUploadImg.vue'
  import honrayRelate from '../inputs/honrayRelate.vue'
  import honrayInterface from '../inputs/honrayInterface.vue'
  export default {
    name: 'commonFormRender',
    props: {
      formField: {  // 控件数据
        type: Array,
        default() {
          return []
        }
      },
      groupList: {  // 分组条件
        type: Array,
        default() {
          return []
        }
      },
      isReadonly: { // 判断是否只读的方法
        type: Function,
        default() {
          return () => {
            return false
          }
        }
      },
      form: { // 表单数据
        type: Object,
        default() {
          return {}
        }
      },
      modelId: {
        type: Number,
        default() {
          return 0
        }
      },
      selectChange: { // 可选控件变化的方法
        type: Function,
        default() {
          return () => {}
        }
      },
      otherChange: { // 输入框可选控件变化的方法
        type: Function,
        default() {
          return () => {}
        }
      },
      complete: { // 是否已完成初始化
        type: Boolean,
        default() {
          return false
        }
      },
      queryForignData: {  // 外键被传参改变的数据
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        editors: [],
        isLoading: false,
        host: '',
        fileType: [
          { id: 10, name: '图片' },
          { id: 20, name: '压缩文件' },
          { id: 30, name: 'word文档' },
          { id: 40, name: 'excel表格' },
          { id: 50, name: 'ppt幻灯片' },
          { id: 60, name: 'PDF' }
        ],
        fieldData: [],
        groupShow: [],
        formulaNameArr: [], // 跟公式有关的字段
        formulas: {},
        fieldDataByName: {},
        keyData: {},
        fillinData: {},
        keyOptions: {},
        rules: {},
        inputRulesList: {}, // 字段规则匹配
        personList: [],
        structList: [],
        extraFieldList: []
      }
    },
    components: {
      honrayInput,
      honrayPassword,
      honrayTextarea,
      honrayRadio,
      honraySelect,
      honrayStruct,
      honrayPeople,
      honrayDate,
      honrayTime,
      honrayDatetime,
      honrayCheckbox,
      honrayUpload,
      honrayEditor,
      honrayCascader,
      honraySubform,
      honrayForeignkey,
      honrayDealtime,
      honrayUser,
      honrayRelate,
      honrayUploadImg,
      honrayInterface
    },
    created() {
      this.host = HOST
    },
    methods: {
      // 接口获取内容传送过来的参数
      transferInfo(data) {
        let keys = []
        _(data).forEach((obj) => {
          _(obj).forEach((value, key) => {
            if (key != 'name') {
              keys.push(key)
            }
          })
        })
        for (let i = 0; i < keys.length; i++) {
          this.form[data[i].name] = data[i][keys[i]]
        }
        _(this.fieldData).forEach((fields) => {
          _(fields).forEach((field) => {
            if (field.default.type == this.TYPE_INPUTTEXT) {
              if (field.input.write_type == this.TYPE_NUMBER) {
                this.form[field.default.name] = parseInt(this.form[field.default.name])
              } else if (field.input.write_type == this.TYPE_FLOATNUMBER) {
                this.form[field.default.name] = parseFloat(this.form[field.default.name])
              }
            }
          })
        })
      },
      isHidden(item) {  // 控件不可见
        return item.default.field_auth == this.INPUT_EXIST
      },
      buildShowData(data) { // 对控件进行分组
        let arrIds = [] // 分组id数组
        let arr = [] // 分组数据
        _(data).forEach((res1) => {
          arrIds.push(res1.default.group_id)
        })
        arrIds = Array.from(new Set(arrIds))
        _(arrIds).forEach((res, key) => {
          arr[key] = []
          _(data).forEach((res1) => {
            if (res1.default.group_id == res) {
              arr[key].push(res1)
            }
          })
        })
        return arr
      },
      async getPersonList() {
        await this.apiGet('cms/deals/fields/1').then((res) => {
          if (res.code == 200) {
            _(res.data).forEach((user) => {
              this.personList.push(user)
            })
          }
        })
      },
      async getStrucList() {
        await this.apiGet('cms/deals/fields/2').then((res) => {
          if (res.code == 200) {
            _(res.data).forEach((struct) => {
              this.structList.push(struct)
            })
          }
        })
      },
      uploading(isUploading) {
        this.$emit('uploading', isUploading)
      },
      getInputRuleList(item) { // 获取字段所匹配规则
        let type = item.default.type
        let name = item.default.name
        // console.log('inputRulesList', this.inputRulesList)
        // 如果是下拉 单选 复选
        if (type === this.TYPE_RADIO ||
          type === this.TYPE_CHECKBOX ||
          type === this.TYPE_SELECT) {
          let option_relation = item.default.option_relation
          if (!option_relation || !option_relation.major_field || option_relation.relation.length === 0) {
            return
          }
          let options = this.getOptions(item)
          // 转化relation
          _(option_relation.relation).forEach((res) => {
            let newOptions = []
            _(res.input_id).forEach((childRes) => {
              _(options).forEach((thirdRes) => {
                if (childRes === thirdRes.name) {
                  newOptions.push(thirdRes)
                  return false
                }
              })
            })
            res.input_id = newOptions
          })
          this.inputRulesList[name] = option_relation
          this.inputRulesList[name].type = type
          return
        }
        // 如果是人员
        if (type === this.TYPE_PERSON) {
          let people_filter = item.default.people_filter
          if (!people_filter || !people_filter.major_field) {
            return
          }
          this.inputRulesList[name] = people_filter
          this.inputRulesList[name].type = type
          return
        }
        // 如果是部门
        if (type === this.TYPE_STRUCT) {
          let struct_filter = item.default.struct_filter
          if (!struct_filter || !struct_filter.major_field) {
            return
          }
          this.inputRulesList[name] = item.default.struct_filter
          this.inputRulesList[name].type = type
          return
        }
        // 如果是外键
        if (type === this.TYPE_FOREIGNKEY) {
          this.inputRulesList[name] = {
            key_cascade: item.default.key_cascade,
            key_depent: item.default.key_depent,
            key_fillin: item.default.key_fillin,
            type: type
          }
          return
        }
      },
      async initData() {  // 根据配置设置验证规则；设置不可见控件的默认值；设置从属关系
        // 获取人员 部门列表
        let isNeedPerson = false
        let isNeedStruct = false
        let rules = {}
        let keyData = {}
        let fillinData = {}
        let hiddenData = []
        this.fieldData.forEach((arr) => {
          arr.forEach((item) => {
            // 获取字段对应规则
            this.getInputRuleList(item)
            let name = item.default.name // 字段名
            let title = item.default.title // 字段标题
            let isNeeded = item.default.is_needed // 是否必填
            let type = item.default.type // 控件类型
            this.fieldDataByName[name] = item
            rules[name] = []
            if (isNeeded) {
              rules[name].push({ required: true, message: `请输入${title}` })
            }
            if (item.default.field_auth == this.INPUT_EXIST &&
                item.default.field_default &&
                _g.isRealEmpty(this.form[name])) {  // 类型为不可见，且值为空，要赋默认值
              if ((type == this.TYPE_INPUTTEXT &&
                  item.input.write_type == this.TYPE_NUMBER) ||
                  type == this.TYPE_RADIO ||
                  type == this.TYPE_SELECT) {  // 类型为数字
                this.form[item.default.name] = parseInt(item.default.field_default)
              } else if (type == this.TYPE_INPUTTEXT && item.input.write_type == this.TYPE_FLOATNUMBER) {  // 类型为浮点型
                this.form[item.default.name] = parseFloat(item.default.field_default)
              } else {  // 类型为字符串
                this.form[item.default.name] = item.default.field_default
              }
            }
            if (item.default.type == this.TYPE_INPUTTEXT) {
              if (item.input.write_type == this.TYPE_NUMBER ||
                item.input.write_type == this.TYPE_FLOATNUMBER ||
                item.input.write_type == this.TYPE_FORMULA) { // 数字类型
                rules[name].push({ validator: this.checkNumberLimit(item), trigger: 'blur' })
              }
              if (item.input.write_type == this.TYPE_FORMULA && item.input.formula) { // 公式
                this.formulas[name] = this.parseFormula(item.input.formula)
                if (_g.isRealEmpty(this.form[name])) {
                  this.form[name] = this.calculateFormula(this.formulas[name])
                } else {
                  this.calculateFormula(this.formulas[name]) // 执行这个是为了生成公式有关的字段数组
                }
              }
            }
            if (item.default.type == this.TYPE_FOREIGNKEY) {
              keyData[item.default.name] = {}
              fillinData[item.default.name] = {}
            }
            if (item.default.field_auth == this.INPUT_EXIST) {
              hiddenData.push(item)
            }
            if (item.default.type === this.TYPE_PERSON) {
              isNeedPerson = true
            }
            if (item.default.type === this.TYPE_STRUCT) {
              isNeedStruct = true
            }
            item.options = this.getOptions(item)
            if (type == this.TYPE_EDITOR) {
              // 富文本编辑器
              this.editors.push(name)
              this.setEditorMenus(item)
            }

            // // 外键连带字段事件触发
            // _(this.queryForignData).forEach((forignItem) => {
            //   if (forignItem === item.default.name) {
            //     this.inputChange(item)
            //   }
            // })
          })
        })
        this.$emit('setComplete', true)
        this.rules = rules
        if (isNeedPerson) {
          await this.getPersonList()
        }
        if (isNeedStruct) {
          await this.getStrucList()
        }
        if (hiddenData.length > 0) {
          _(hiddenData).forEach((res) => {
            this.inputChange(res, true)
          })
        }
        this.keyData = keyData
        this.fillinData = fillinData
      },
      setEditorMenus(item) { // 设置编辑器菜单
        let disabledMenus = ['img', 'location', 'emotion', 'video', 'insertcode']
        let menusString = disabledMenus.join(',')
        item.uploadImgUrl = ''
        item.hideLinkImg = true
        _(item.editor.pc_config).forEach((res) => {
          switch (res) {
            case this.MENU_UPLOAD: // 图片上传
              menusString = menusString.replace('img', '').replace(',,', ',')
              item.uploadImgUrl = HOST + 'form/upload/' + item.default.field_id
              break
            case this.MENU_WEB_IMAGE: // 网络图片
              menusString = menusString.replace('img', '').replace(',,', ',')
              item.hideLinkImg = false
              break
            case this.MENU_VIDEO: // 视频
              menusString = menusString.replace('video', '').replace(',,', ',')
              break
            case this.MENU_CODE: // 代码
              menusString = menusString.replace('insertcode', '').replace(',,', ',')
              break
            case this.MENU_FACELOOK: // 表情
              menusString = menusString.replace('emotion', '').replace(',,', ',')
              break
          }
        })
        if (menusString.length && menusString[0] == ',') {
          menusString = menusString.substr(1, menusString.length)
        }
        item.disabledMenus = menusString.split(',')
      },
      getCol(val) {
        let col = 24
        switch (val) {
          case 10:
            col = 24
            break
          case 20:
            col = 12
            break
          case 30:
            col = 8
            break
          case 40:
            col = 6
            break
        }
        return col
      },
      updateRender(_groupList) {
        let self = this
        // 兼容旧数据，如果存在_groupList为空时，也默认打开
        _(self.fieldData).forEach((fres) => {
          _(fres).forEach((frres) => {
            if (frres.default.group_id != undefined && _groupList.length != 0) {
              _(_groupList).forEach((res) => {
                if (frres.default.group_id == res.group_id) {
                  frres.default.show = res.show
                }
              })
            } else {
              frres.default.show = true
            }
          })
        })
      },
      getUnitText(unit) {
        let outputUnit = 'KB'
        switch (unit) {
          case 10:
            outputUnit = 'KB'
            break
          case 20:
            outputUnit = 'MB'
            break
        }
        return outputUnit
      },
      valueChange(item) { // 值改变时执行的方法
        let type = item.default.type
        let name = item.default.name
        if (type == this.TYPE_RADIO ||
            type == this.TYPE_CHECKBOX ||
            type == this.TYPE_SELECT ||
            type == this.TYPE_FOREIGNKEY) { // 有选项的控件
          // this.selectChange(item)
        } else {
          this.otherChange()
        }
        // 事件规则对应事件
        this.inputChange(item)
        if (_.indexOf(this.formulaNameArr, name) > -1) { // 如果是公式中出现的字段
          _(this.fieldData).forEach((arr) => {
            arr.forEach((res) => {
              if (res.default.type == this.TYPE_INPUTTEXT) {
                if (res.input.write_type == this.TYPE_FORMULA && this.formulas[res.default.name] && res.default.name != name) { // 公式
                  this.form[res.default.name] = this.calculateFormula(this.formulas[res.default.name])
                }
              }
            })
          })
        }
      },
      inputChange(item, isReset) {
        let name = item.default.name
        let type = item.default.type
        let value = this.form[name]
        // 遍历当前规则对象列表
        _(this.inputRulesList).forEach((res, key) => {
          let target = this.fieldDataByName[key]
          // 如果是 人员 / 部门 (其他控件影响自身控件)
          if (res.type === this.TYPE_PERSON || res.type === this.TYPE_STRUCT) {
            let obj_key = res.type === this.TYPE_PERSON ? 'realname' : 'name'
            let list = res.type === this.TYPE_PERSON ? this.personList : this.structList
            if (res.major_field === name) { // 该字段和此规则存在关联
              let newOptions = []
              target.options = this.getOptions(target)
              if (!value) {
                return
              }
              if (res.filter_field) { // 使用人员 / 部门关联表单字段对比
                // 过滤字段
                let key = ''
                _(list).forEach((itemList) => {
                  if (itemList.field_id === res.filter_field) {
                    key = itemList.field
                  }
                })
                _(target.options).forEach((childRes) => {
                  if (childRes[key]) {
                    childRes[key] = _.toString(childRes[key])
                    if (childRes[key].indexOf(value) !== -1) {
                      newOptions.push(childRes)
                    }
                  }
                })
              } else {
                // 根据 value 和 选项中的value进行筛选数据
                _(target.options).forEach((childRes) => {
                  if (childRes[obj_key]) {
                    childRes[obj_key] = _.toString(childRes[obj_key])
                    if (childRes[obj_key].indexOf(value) !== -1) {
                      newOptions.push(childRes)
                    }
                  }
                })
              }
              target.options = newOptions
              if (!isReset) {
                this.resetFormData(target.default.name)
              }
            }
          }
          // 如果是下拉框 复选框 单选框 (其他控件影响自身控件)
          if (res.type === this.TYPE_RADIO || res.type === this.TYPE_CHECKBOX || res.type === this.TYPE_SELECT) {
            if (res.major_field === name) { // 该字段和此规则存在关联
              let newOptions = []
              target.options = this.getOptions(target)
              let relation = res.relation
              if (type === this.TYPE_CHECKBOX) { // 复选框
                if (_.isArray(value) && value.length === 0) {
                  return
                }
                _(relation).forEach((childRes) => {
                  _(value).forEach((thirdRes) => {
                    if (childRes.option_name.name === thirdRes) {
                      newOptions.push.apply(newOptions, childRes.input_id)
                      return false
                    }
                  })
                })
                newOptions = this.distintArray(newOptions)
              } else { // 下拉框 单选框
                if (!value) {
                  return
                }
                _(relation).forEach((childRes) => {
                  if (childRes.option_name.value === value) {
                    newOptions = childRes.input_id
                    return false
                  }
                })
              }
              target.options = newOptions
              if (!isReset) {
                this.resetFormData(target.default.name)
              }
              // this.resetFormData(target.default.name)
              // console.log('下拉框 复选框 单选框最终选项', target.options)
            }
          }
          if (res.type === this.TYPE_FOREIGNKEY) { // 外键
            // 如果当前改变控件是外键，则会对 连带字段填充本表控件 进行处理
            if (type === this.TYPE_FOREIGNKEY) {
              // 查看当前外键字段是否有 1 规则存在
              if (res.key_fillin) {
                let tempData = {}
                tempData[name] = {}
                let vaild = target.key.is_link == 1
                if (vaild) {
                  tempData = target.fillData
                } else {
                  tempData = this.fillinData
                }
                this.setKeyFillin(name, target, tempData)
              }
              if (res.key_cascade && res.key_cascade.major_field === name) { // 字段存在关联
                target.options = this.getOptions(target)
                this.setKeyExtra(name, res, target)
              }
            }
          }
        })
      },
      setKeyData(name, data) {
        this.keyData[name] = data.depentData
        this.fillinData[name] = data.fillinData
        let target = this.fieldDataByName[name]
        target.options = this.getOptions(target)
        // if (data.fillinData) {
        //   this.setKeyFillin(name, target, this.fillinData)
        // }
        // _(this.inputRulesList).forEach((res, key) => {
        //   if (res.type === this.TYPE_FOREIGNKEY) { // 外键
        //     if (res.key_cascade && res.key_cascade.major_field === name) {
        //       this.setKeyExtra(name, res, target)
        //     }
        //   }
        // })
        // 外键连带字段事件触发
        _(this.queryForignData).forEach((forignItem) => {
          if (forignItem === target.default.name) {
            this.inputChange(target)
          }
        })
      },
      setEfficientOptions(name, options) {
        let target = this.fieldDataByName[name]
        target.options = this.getOptions(target)
      },
      setKeyOptions(name, options) {  // 设置外键选项，满足公式需求
        this.keyOptions[name] = options
      },
      setKeyFillin(name, target, fillinData) { // 设置外键填充规则影响其他组件
        // 是否有填充规则
        let tempFillinData = {}
        if (this.form[name] === null) {
          return
        }
        if (this.inputRulesList[name]) {
          let res = this.inputRulesList[name]
          if (res.key_fillin && res.key_fillin.length > 0) {
            if (!fillinData) {
              return
            }
            tempFillinData = fillinData
            _(res.key_fillin).forEach((childRes) => {
              if (childRes.fill_field && childRes.be_fill_field) {
                // 进入填充规则， 获取填充规则字段的值
                // ? 如果不是本表单
                let fillValue
                if (this.form[name] && tempFillinData[name] && tempFillinData[name][this.form[name]]) {
                  fillValue = tempFillinData[name][this.form[name]][childRes.fill_field]
                } else {
                  fillValue = ''
                }
                // 赋值
                this.form[childRes.be_fill_field] = fillValue
              }
            })
          }
        }
      },
      setKeyExtra(name, res, target) { // 设置外键联动
        // 判断主字段是否存在
        if (res.key_cascade && res.key_cascade.major_field && res.key_cascade.extra_field) {
          // 被筛选外键的字段
          let extra_field = res.key_cascade.extra_field
          let major_field = res.key_cascade.major_field
          let newOptions = []
          if (!this.form[major_field]) {
            this.resetFormData(target.default.name)
            return
          }
          _(target.options).forEach((item) => {
            if (item[extra_field]) {
              if (item[extra_field] === this.form[major_field]) {
                newOptions.push(item)
              }
            }
          })
          target.options = newOptions
          this.resetFormData(target.default.name)
        }
      },
      validate(func) {
        this.$refs.form.validate(func)
      },
      getOptions(item) {
        let type = item.default.type
        let options = []
        if (type == this.TYPE_RADIO) {
          options = item.radio_option
        } else if (type == this.TYPE_CHECKBOX) {
          options = item.checkbox_option
        } else if (type == this.TYPE_SELECT) {
          options = item.select_option
        } else if (type == this.TYPE_PERSON) {
          options = item.people_option
        } else if (type == this.TYPE_STRUCT) {
          options = item.struct_option
        } else if (type == this.TYPE_FOREIGNKEY) {
          if (item.allOptions === undefined) {
            options = []
          } else {
            options = item.allOptions
          }
        }
        return options
      },
      parseFormula(str) { // 解析公式
        str = str.replace(/\s/g, '').replace(/\"/g, '')
        var stack = new Stack.Stack()
        var outStack = []
        var cutIndex = 0
        for (var i = 0; i < str.length; ++i) {
          if (str[i] == ')') {
            let cut = str.substring(cutIndex, i)
            if (cut) {
              outStack[outStack.length] = cut
            }
            cutIndex = i + 1
            while (true) {
              var top = stack.peek()
              stack.pop()
              if (top != '(') {
                outStack[outStack.length] = top
              } else {
                break
              }
            }
          } else if (['-','+'].indexOf(str[i]) > -1) {
            let cut = str.substring(cutIndex, i)
            if (cut) {
              outStack[outStack.length] = cut
            }
            cutIndex = i + 1
            if (['*','/'].indexOf(stack.peek()) > -1) {
              while (['*','/'].indexOf(stack.peek()) > -1) {
                outStack[outStack.length] = stack.peek()
                stack.pop()
              }
              outStack[outStack.length] = str[i]
            } else if (['+','-'].indexOf(stack.peek()) > -1) {
              while (['+','-'].indexOf(stack.peek()) > -1) {
                outStack[outStack.length] = stack.peek()
                stack.pop()
              }
              stack.push(str[i])
            } else {
              stack.push(str[i])
            }
          } else if (['(','*','/'].indexOf(str[i]) > -1) {
            let cut = str.substring(cutIndex, i)
            if (cut) {
              outStack[outStack.length] = cut
            }
            cutIndex = i + 1
            stack.push(str[i])
          }
          if (i == str.length - 1) {
            let cut = str.substring(cutIndex, str.length)
            if (cut) {
              outStack[outStack.length] = (cut)
            }
          }
        }
        while (stack.length()) {
          outStack[outStack.length] = stack.pop()
        }
        return outStack
      },
      calculateFormula(formulaStack) {
        let result = 0
        let operators = ['+', '-', '*', '/']
        let a = ''
        let b = ''
        let varStack = []
        let operatorStack = []
        _(formulaStack).forEach((res) => {
          if (_.indexOf(operators, res) > -1) { // 是运算符
            if (varStack.length > 1) {
              a = varStack.pop()
              b = varStack.pop()
              result = _g.handleCompute(b, a, res)
              varStack.push(result)
            } else {
              operatorStack.push(res)
            }
          } else {
            varStack.push(this.getNumber(res))
          }
        })
        _(operatorStack).forEach((res) => {
          if (varStack.length > 1) {
            a = varStack.pop()
            b = varStack.pop()
            result = _g.handleCompute(b, a, res)
            varStack.push(result)
          }
        })
        result = parseFloat(result.toFixed(2)) // 后面改成可配置
        return result
      },
      getNumber(a) { // 获取计算用的数字
        if (_verify.isNumber(a)) {
          a = parseFloat(a)
        } else if (a.indexOf('.') > -1) { // 有可能是外键
          let str = a.split('.')
          a = 0
          if (str.length > 1) {
            let name = str[0]
            let key = str[1]
            this.setFormulaNameArr(name)
            if (this.keyOptions[name] &&
                this.keyOptions[name].length &&
                this.form[name]) {
              _(this.keyOptions[name]).forEach((res) => {
                if (res.id == this.form[name]) {
                  if (res[key]) {
                    a = parseFloat(res[key])
                  } else {
                    a = 0
                  }
                  return false
                }
              })
            }
          }
        } else if (!_g.isRealEmpty(this.form[a]) && !isNaN(this.form[a])) {
          this.setFormulaNameArr(a)
          a = parseFloat(this.form[a])
        } else {
          let getDefault = false
          _(this.formField).forEach((res) => {
            if (res.default.name == a) {
              if (res.default.type == this.TYPE_INPUTTEXT) { // 单行文本默认值
                this.setFormulaNameArr(a)
                a = parseFloat(res.input.write_default)
                getDefault = true
              } else if (res.default.type == this.TYPE_RADIO ||
                         res.default.type == this.TYPE_SELECT) { // 单选或者下拉
                this.setFormulaNameArr(a)
                a = 0
                getDefault = true
              }
              return false
            }
          })
          if (!getDefault || isNaN(a)) {
            a = 0
          }
        }
        return a
      },
      // handleCompute(a, b, type) { // 执行四则运算
      //   // js浮点数运算有bug，需转化成整形数运算再还原
      //   let result = 0
      //   let multiA = 1
      //   let multiB = 1
      //   if (!_g.isRealEmpty(a) && a.toString().indexOf('.') > -1) {
      //     let string = a.toString().replace(/\d+./, '')
      //     if (string) {
      //       multiA *= Math.pow(10, string.length)
      //     }
      //   }
      //   if (!_g.isRealEmpty(b) && b.toString().indexOf('.') > -1) {
      //     let string = b.toString().replace(/\d+./, '')
      //     if (string) {
      //       multiB *= Math.pow(10, string.length)
      //     }
      //   }
      //   let multi = Math.max(multiA, multiB)
      //   if (multiA == 1) {
      //     a *= multi
      //   } else {
      //     a = parseFloat(a.toString().replace('.', ''))
      //   }
      //   if (multiB == 1) {
      //     b *= multi
      //   } else {
      //     b = parseFloat(b.toString().replace('.', ''))
      //   }
      //   switch (type) {
      //     case '+':
      //       result = (a + b) / multi
      //       break
      //     case '-':
      //       result = (a - b) / multi
      //       break
      //     case '*':
      //       result = (a * b) / (multi * multi)
      //       break
      //     case '/':
      //       result = (a / b) / (multi * multi)
      //       break
      //   }
      //   return result
      // },
      removeRepeat(arr) { // 去重
        return Array.from(new Set(arr))
      },
      setFormulaNameArr(name) { // 设置跟公式有关的字段的数组
        this.formulaNameArr.push(name)
        this.formulaNameArr = this.removeRepeat(this.formulaNameArr)  // 去重
      },
      resetFormData(name) {
        if (this.form[name] instanceof Array) {  // 根据字段值类型置空
          this.form[name] = []
        } else {
          this.form[name] = ''
        }
      },
      distintArray(arr) {
        let result = []
        let obj = {}
        _(arr).forEach((res, index) => {
          if (!obj[res.name]) {
            result.push(res)
            obj[res.name] = 1
          }
        })
        return result
      },
      checkNumberLimit(item) {  // 构造检验数字大小的规则函数
        let minLimit = ''
        let maxLimit = ''
        if (item) {
          minLimit = item.input.min_limit
          maxLimit = item.input.max_limit
        }
        return (rule, value, callback) => {
          if (!_g.isRealEmpty(value)) {
            if (!_g.isRealEmpty(minLimit) && !_g.isRealEmpty(maxLimit)) { // 最大值最小值都有
              if (value > maxLimit || value < minLimit) {
                callback(`所输入值必须在${minLimit}和${maxLimit}间`)
                return
              }
            } else if (!_g.isRealEmpty(minLimit)) { // 只设置了最小值
              if (value < minLimit) {
                callback(`所输入值不能小于${minLimit}`)
                return
              }
            } else if (!_g.isRealEmpty(maxLimit)) { // 只设置了最大值
              if (value > maxLimit) {
                callback(`所输入值不能大于${maxLimit}`)
                return
              }
            }
          }
          callback()
        }
      }
    },
    mixins: [http, modelConfig, flowConfig, cmsConfig],
    watch: {
      'formField'() {
        this.fieldData = this.buildShowData(this.formField)
        this.initData()
        this.updateRender(this.groupList)
      },
      'form'() {
      }
    }
  }
</script>


// WEBPACK FOOTER //
// commonFormRender.vue?7340520a